import { render, staticRenderFns } from "./ProductResourceForm.vue?vue&type=template&id=6e56ca3e&"
import script from "./ProductResourceForm.vue?vue&type=script&lang=js&"
export * from "./ProductResourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports